<template>
    <div class="description-label">
        <div v-for="(line, index) in lines" :key="index" class="description-line"
            :class="{ warning: /attention/i.test(line) }">
            {{ line || '\u00A0' }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    text: {
        type: String,
        required: true
    }
})

const lines = computed(() => props.text.split('\n'))
</script>

<style scoped lang="scss">
.description-label {
    color: $dark-gray;
    font-weight: normal;
    margin-top: .5em;

    white-space: pre-line;
}

.description-line {
    margin: 0;
}

.warning {
    color: red;
    font-weight: bold;
}
</style>